<!-- 
화면명 : PopupMagam.vue
작성일 : 2025-07-01
설명   : 메인 홈화면 - 그리드 클릭시 팝업 화면
-->
<template>
  <!-- class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-999" -->
  <teleport to="body">
    <div
      v-if="visible"
      class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[9999]"
    >
      <div
        class="bg-white rounded-lg shadow-lg p-1"
        style="width: 700px; height: 550px"
      >
        <!-- 상단 제목줄 -->
        <div
          class="bg-gray-500 px-4 py-3 font-bold text-white text-center relative"
        >
          {{ title }}
          <!-- 닫기 버튼 -->
          <button
            class="absolute top-2 right-4 bg-blue-500 text-white hover:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
            @click="close"
          >
            닫기
          </button>
        </div>

        <!-- 내용 테이블 -->
        <table class="table-fixed w-full border-t">
          <tbody>
            <!-- 보낸이 + 날짜 -->
            <tr class="border-b">
              <td
                class="w-28 bg-blueGray-50 px-4 py-2 font-semibold text-blueGray-600"
              >
                보낸이
              </td>
              <td class="px-4 py-2 text-blueGray-800">{{ sender }}</td>
              <td class="w-48 px-4 py-2 text-right text-blueGray-500">
                {{ date }}
              </td>
            </tr>

            <!-- 내용 -->
            <tr class="border-b align-top">
              <td
                class="bg-blueGray-50 px-4 py-2 font-semibold text-blueGray-600"
              >
                내용
              </td>
              <td
                colspan="2"
                class="px-4 py-3 whitespace-pre-line text-blueGray-800"
              >
                {{ content }}
              </td>
            </tr>

            <!-- 첨부파일1 -->
            <tr class="border-b">
              <td
                class="bg-blueGray-50 px-4 py-2 font-semibold text-blueGray-600"
              >
                첨부파일1
              </td>
              <td colspan="2" class="px-4 py-2 text-blueGray-800">없음</td>
            </tr>

            <!-- 첨부파일2 -->
            <tr class="border-b">
              <td
                class="bg-blueGray-50 px-4 py-2 font-semibold text-blueGray-600"
              >
                첨부파일2
              </td>
              <td colspan="2" class="px-4 py-2 text-blueGray-800">없음</td>
            </tr>

            <!-- 첨부파일3 -->
            <tr class="border-b">
              <td
                class="bg-blueGray-50 px-4 py-2 font-semibold text-blueGray-600"
              >
                첨부파일3
              </td>
              <td colspan="2" class="px-4 py-2 text-blueGray-800">없음</td>
            </tr>
          </tbody>
        </table>

        <hr class="mb-4 border-b-1 border-blueGray-200" />

        <!-- 확인 버튼 -->
        <!-- <div class="flex justify-end">
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            @click="close"
          >
            확인
          </button>
        </div> -->
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: Boolean,
  title: { type: String, default: "" },
  sender: { type: String, default: "" },
  date: { type: String, default: "" },
  content: { type: String, default: `` },
  attachments: {
    type: Array,
    default: () => [""], // 3개 자리 비워두기
  },
});
const emit = defineEmits(["update:modelValue", "emit-close"]);

const visible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  }
);

function close() {
  visible.value = false;
  emit("emit-close", false);
}
</script>
